module.exports = global["jQuery"] = require("-!/home/idiomas.uach.mx/tmp/build-173255039510558/node_modules/expose-loader/index.js?$!./jquery.js");